import { QueryClient } from 'react-query';

const queryClient = new QueryClient();

const queryKeys = {
  datoData: 'dato-data',
};

export { queryClient, queryKeys };
